// ** This file contains useful helper/utility functions that may be repeated throughout this project **
import { API_BASE_URL } from "./config";

export const updateUserProgress = async (exercise, duration, errorRate) => {
    try {
      const exerciseMapping = {
        1: [1, 3, 5, 8, 10],
        2: [5, 10],
        3: [5, 10],
        4: [5, 10],
        5: [5, 10],  // Skipping 6
        6: [2, 4, 6, 8, 10],  // Skipping 8
        7: [2, 4, 6, 8, 10],  // Exercise 10
        8: [2, 4, 6, 8, 10]
      };

      const durations = exerciseMapping[exercise];

      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found!..");

    // Fetch user data first
    const userResponse = await fetch(`${API_BASE_URL}/api/user/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const userData = await userResponse.json();
    console.log("Fetched user data:", userData);

      let updatedProgress = {errorRates: {
        ...userData.errorRates,[`exercise${exercise}`]: errorRate}};
      console.log("fetch called:", userData);

      // // If the user has NOT finished all levels in this exercise, increment currNumLevelsUnlocked
      // if (userData.numExercisesUnlocked === exercise && userData.currNumLevelsUnlocked === (durations.indexOf(duration) + 1) && userData.currNumLevelsUnlocked < durations.length) {
      //   updatedProgress = {
      //     numExercisesUnlocked: userData.numExercisesUnlocked,
      //     currNumLevelsUnlocked: userData.currNumLevelsUnlocked + 1,
      //   };
      // }
      // // If the user has finished all levels in this exercise, unlock the next exercise
      // else if (userData.numExercisesUnlocked === exercise && userData.currNumLevelsUnlocked === (durations.indexOf(duration) + 1) && userData.currNumLevelsUnlocked === durations.length) {
      //   updatedProgress = {
      //     numExercisesUnlocked: userData.numExercisesUnlocked + 1, // Unlock exercises 6 and 7 if finishing exercise 5
      //     currNumLevelsUnlocked: 1, // Reset levels for new exercise
      //   };

      // // Ensure exercise 6 is also unlocked when finishing exercise 5
      //   if (exercise === 5) {
      //       updatedProgress.numExercisesUnlocked = 7
      //       updatedProgress.currNumLevelsUnlocked = 1 // Skip from 5 to 7, unlocking 6 in the process
      //   }
      // } else {
      //   return; // Exit early if no update is required
      // }

      // New Updating Logic
      let i = exercise - 1; // exercise index
      let durationIndex = durations.indexOf(duration);

      if (duration === -1) {
        updatedProgress = {
          exercisesUnlocked: userData.exercisesUnlocked.map((level, index) =>
            index === i ? 1 : level
          ),
        };
      } else if (exercise === 1) {
        // Exercise 1 logic
        if (userData.exercisesUnlocked[0] === 5 && durationIndex + 1 === 5) {
          // Unlock warmups for all other exercises and incrememnt exercise1 level to 6 so we don't hit this conditional again
          updatedProgress = {
            exercisesUnlocked: userData.exercisesUnlocked.map((level, index) =>
              index === 0 ? 6 : 0
            ),
          };
        } else if (userData.exercisesUnlocked[0] < 5 && durationIndex + 1 === userData.exercisesUnlocked[0]) {
          // Go to next level for exercise 1
          updatedProgress = {
            exercisesUnlocked: userData.exercisesUnlocked.map((level, index) =>
              index === 0 ? level + 1 : level
            ), // Increment at index 0 (the first exercise)
          };
        }

      } else if (0 <= userData.exercisesUnlocked[i] < durations.length && userData.exercisesUnlocked[i] === (durationIndex + 1)) {
        // All other exercises (if warmup or current max duation then increment)
        console.log('yoo', userData.exercisesUnlocked.map((level, index) => index === i ? level + 1 : level));
        updatedProgress = {
          exercisesUnlocked: userData.exercisesUnlocked.map((level, index) =>
            index === i ? level + 1 : level
          ), // Increment at index i
        };
      }
      console.log(updatedProgress)

      // Send the update to the backend
      const response = await fetch(`${API_BASE_URL}/api/user/progress`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedProgress),
      });


  } catch (error) {
    console.error("Error updating progress:", error);
  }
};
